import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Button, Form, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { EmployeeSelect } from "@icoach/components/";
import useOrderApi from "@apis/useOrderApi";
import { useEmployeeApi } from "@apis/useEmployeeApi";
import { refIsRequiredError, isFunction } from "@util/utils";

const DeleteOrderDialogDialogContent = React.forwardRef((props, ref) => {
	const { options } = props;
	const employeeRef = useRef(null);
	const reasonTextRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				let result = {};
				if (employeeRef.current && employeeRef.current.getResult) {
					result = Object.assign(result, { employeeID: employeeRef.current.getResult() });
				}
				if (reasonTextRef.current && reasonTextRef.current.getResult) {
					result = Object.assign(result, {
						reasonText: reasonTextRef.current.getResult(),
					});
				}
				return result;
			},
			isError: () => refIsRequiredError(employeeRef, reasonTextRef),
		}), // eslint-disable-next-line
		[],
	);

	return (
		<DialogContent>
			<Grid spacing={3} container>
				<Grid xs={12} item>
					<EmployeeSelect ref={employeeRef} options={options} label="擔當" fullWidth required />
				</Grid>
				<Grid xs={12} item>
					<TextField ref={reasonTextRef} label="刪除原因" minRows={2} multiline fullWidth />
				</Grid>
			</Grid>
		</DialogContent>
	);
});

const DeleteOrderDialog = props => {
	const { className, open, sourceData, onClose, refresh } = props;
	const orderID = sourceData?.orderID;
	const { putOrderDeleteApi } = useOrderApi();
	const { getEmployeesOptionsApi } = useEmployeeApi();
	const [options, setOptions] = useState([]);
	const contentRef = useRef();

	const doOrderDeleteApi = async (orderID, params) => {
		let res = await putOrderDeleteApi(orderID, params);
		if (res) {
			isFunction(refresh) && refresh();
			isFunction(onClose) && onClose();
		}
	};

	const doEmployeesOptionsApi = async () => {
		let res = await getEmployeesOptionsApi();
		if (res) {
			setOptions(res);
		}
	};
	const getParams = () => {
		let result = {};

		if (contentRef.current && contentRef.current.getResult) {
			result = Object.assign(result, contentRef.current.getResult());
		}

		return result;
	};
	const handleSubmit = () => {
		let isError = contentRef.current && contentRef.current.isError();
		if (!isError) {
			let params = getParams();
			doOrderDeleteApi(orderID, params);
		}
	};

	useEffect(
		() => {
			if (open) doEmployeesOptionsApi();
		},
		// eslint-disable-next-line
		[open],
	);

	if (!open) return null;

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>刪除訂單</GradientColorHeader>
			<DeleteOrderDialogDialogContent ref={contentRef} options={options} />
			<DialogActions>
				<Button type="submit" variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteOrderDialog;
